import {VetReservation} from "../vet-reservation.model";
import {User} from "../user.model";
import {VetClinic} from "../vet-clinic.model";
import {KsefVetineoStatus} from "../ksef-vetineo-status";

/**
 * Główny model reprezentujący zamówienie (transakcję finansową) w systemie.
 * Przechowuje komplet informacji o płatności, danych do faktury (wraz z integracją z KSeF), kupującym oraz zakupionej usłudze (`vetReservation`).
 * Klasa zawiera również logikę pomocniczą (Helpers) do wizualizacji statusu zamówienia w interfejsie użytkownika
 * (zamiana kodów liczbowych na etykiety tekstowe, ikony i kolory).
 */
export class Order {

  public created: string;
  public number: string;
  public uuid: string;
  public appUserId: number;
  public statusId: number;

  public bmRemoteId: string;
  public paymentGatewayId: number;

  public bmConfirmationDate;
  public vetcodeId: number;
  public orderType: number;
  public amount: number;
  public name: string;
  public surname: string;
  public phone: string;
  public countryCode: string;
  public countryId: number;
  public addressName: string;
  public description: string;
  public postalCode: string;
  public city: string;
  public street: string;
  public streetNumber: string;
  public companyName: string;
  public companyNip: string;
  public companyCountry: string;
  public companyCountryId: number;
  public companyPostalCode: string;
  public companyCity: string;
  public companyStreet: string;
  public companyStreetNumber: string;
  public transactionId: string;
  public p24ConfirmationDate: string;
  public p24OrderId: string;
  public p24TransactionId: string;
  public p24TransactionToken: string;
  public vetReservation: VetReservation;
  public refundUUID: string;
  public user: User;
  public settlementStatus: string;
  public errorType: string;
  public wasCompleted: boolean;
  public wasAnError: boolean;

  public invoiceNumber: string;
  public correctiveInvoiceNumber: string;
  public receiptWasIssued: boolean;
  public receiptIssued: string;
  public vetClinic: VetClinic;
  public reservationType: string;
  public buyerType: string;

  /** Status wysyłki do KSeF. */
  public govStatus: string;
  /** Unikalny numer KSeF faktury (format: {NIP}-{DATA}-{ID}). */
  public govId: string;
  /** Data i czas wysyłki do KSeF. */
  public govSendDate: string;
  /** Data sprzedaży zarejestrowana w KSeF. */
  public govSellDate: string;
  /** Lista błędów walidacji lub wysyłki. Wartość null oznacza brak błędów lub brak walidacji. */
  public govErrorMessages: string;
  /** Link do weryfikacji faktury w portalu KSeF (używany do generowania QR). */
  public govVerificationLink: string;
  /** Bezpośredni link do faktury w portalu KSeF (używany do generowania QR). */
  public govLink: string;
  /** Numer korygowanego dokumentu (dla faktur korygujących). */
  public govCorrectedInvoiceNumber: string;
  /** Status wysyłki faktur do KSeF w systemie Vetineo. */
  public kSeFVetineoStatus: KsefVetineoStatus;
  /** Pola, których nie otrzymano z odpowiedzi Fakturowni po zgłoszeniu faktury do KSeF. */
  public govMissingFields: string;
  /** Numer paragonu niezbędny do wysyłki w KSeF. */
  public receiptNumber: string;

  public getOrderStatus(): string {
    switch (this.statusId) {
      case 30: {
        return 'PAYMENT_ERROR_STATUS_ID';
      }
      case 60: {
        return 'DELETED_STATUS_ID';
      }
      case 90: {
        return 'CANCELED_STATUS_ID';
      }
      case 100: {
        return 'NEW_STATUS_ID';
      }
      case 200: {
        return 'WAITING_FOR_PAYMENT_STATUS_ID';
      }
      case 300: {
        return 'PAYMENT_CONFIRMED_STATUS_ID';
      }
      default: {
        return undefined;
      }
    }
  }

  public getOrderIcon(): string {
    switch (this.statusId) {
      case 30: {
        return 'alert-circle-outline';
      }
      case 60: {
        return 'alert-circle-outline';
      }
      case 90: {
        return 'trash-outline';
      }
      case 100: {
        return 'add-circle-outline';
      }
      case 200: {
        return 'time-circle-outline';
      }
      case 300: {
        return 'checkmark-circle-outline';
      }
      default: {
        return undefined;
      }
    }
  }


  public getOrderColor(): string {
    switch (this.statusId) {
      case 30: {
        return 'danger';
      }
      case 60: {
        return 'alert-circle-outline';
      }
      case 90: {
        return 'trash-outline';
      }
      case 100: {
        return 'add-circle-outline';
      }
      case 200: {
        return 'time-circle-outline';
      }
      case 300: {
        return 'success';
      }
      default: {
        return undefined;
      }
    }
  }

  constructor() {
  }
}
